/**
 * src/utils/undoRedo/commands/CopyCommand.js
 * Nesne kopyalama komutu
 */

import BaseCommand from './BaseCommand';
import { clearSelection } from '../../../redux/selectionSlice';

class CopyCommand extends BaseCommand {
  /**
   * @param {THREE.Object3D[]} clonedObjects - Sahneye eklenmiş klonlar
   */
  constructor(clonedObjects) {
    super('COPY_OBJECTS', {
      before: null,
      after: { ids: clonedObjects.map(o => o.userData.id) }
    });
    this.clonedObjects = clonedObjects;
  }

  /**
   * Redo: Klonları sahneye geri ekle
   */
  execute(scene, dispatch) {
    this.clonedObjects.forEach(obj => scene.add(obj));
    if (dispatch) dispatch(clearSelection());
  }

  /**
   * Undo: Klonları sahneden kaldır (dispose etmeden!)
   */
  undo(scene, dispatch) {
    this.clonedObjects.forEach(obj => scene.remove(obj));
    if (dispatch) dispatch(clearSelection());
  }
}

export default CopyCommand;
